// extracted by mini-css-extract-plugin
export default {"cards":"Wishlist_cards__+RDWe"};